module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAYBAMAAAB6qqLzAAAAKlBMVEUAmZn///9As7PA5uaAzMwwrKwgpqbw+flwxsbQ7OwQn5+w39+g2dlgv78C0utJAAAAgklEQVQY02OgFQhSUlJawKQKZLFqwQUNBQUFFRgFAxgYmIUQgiYuLgmMghNQBR2ABKOgCBZBGcEATEEhwwlYBNMlwIII24WBghziCZiCDIYGmNoZ0iWwCHKIL8YQBDI2YxEMFEf1pgJIkEUQxXZBB0YQfyJC8IoLUCWLG5AVAiRoAwABoRT5/sTwHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-en.png
// module id = 18In
// module chunks = 1